var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTraining = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Available Filters - 01")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BITACore-Resources-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-287.000000, -449.000000)",
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(271.000000, 422.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(14.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Notification-/-phone_in_talk",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 16.54 0 16.54 17 0 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3375,8.5 L11.7158333,8.5 C11.7158333,6.545 10.1721,4.95833333 8.27,4.95833333 L8.27,6.375 C9.41401667,6.375 10.3375,7.32416667 10.3375,8.5 Z M13.0941667,8.5 L14.4725,8.5 C14.4725,4.97958333 11.6951583,2.125 8.27,2.125 L8.27,3.54166667 C10.937075,3.54166667 13.0941667,5.75875 13.0941667,8.5 Z M13.7833333,10.9791667 C12.921875,10.9791667 12.094875,10.8375 11.3230083,10.5754167 C11.2540917,10.5541667 11.1782833,10.54 11.1093667,10.54 C10.9301833,10.54 10.7578917,10.6108333 10.6200583,10.7454167 L9.10389167,12.30375 C7.15355,11.28375 5.55468333,9.6475 4.56228333,7.63583333 L6.07845,6.07041667 C6.27141667,5.88625 6.32655,5.61 6.25074167,5.36208333 C5.99575,4.56875 5.85791667,3.71875 5.85791667,2.83333333 C5.85791667,2.44375 5.54779167,2.125 5.16875,2.125 L2.75666667,2.125 C2.377625,2.125 2.0675,2.44375 2.0675,2.83333333 C2.0675,9.48458333 7.31205833,14.875 13.7833333,14.875 C14.162375,14.875 14.4725,14.55625 14.4725,14.1666667 L14.4725,11.6875 C14.4725,11.2979167 14.162375,10.9791667 13.7833333,10.9791667 Z M3.46650833,3.54166667 L4.50025833,3.54166667 C4.5485,4.165 4.651875,4.78125 4.81038333,5.36916667 L3.98338333,6.22625 C3.70771667,5.36916667 3.52853333,4.47666667 3.46650833,3.54166667 L3.46650833,3.54166667 Z M13.0941667,13.4370833 C12.1844667,13.3733333 11.3023333,13.1891667 10.4753333,12.89875 L11.3023333,12.04875 C11.888125,12.21875 12.4877,12.325 13.0941667,12.3675 L13.0941667,13.4370833 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  }))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTraining, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/training.a1db9fb2.svg";
export { ForwardRef as ReactComponent };